// 侧边栏折叠状态，语言等全局状态
import { defineStore } from "pinia";
import i18n from "../plugins/i18n";

/**
 * 应用全局状态管理 Store
 * 用于管理应用的语言设置和其他全局配置
 */
export const useAppStore = defineStore("app", {
  state: () => ({
    // 当前选中的语言代码
    lang: "en-US",
    // 支持的语言列表
    langs: [
      { code: "en-US", name: "English" },
      { code: "zh-CN", name: "中文" },
      { code: "ja-JP", name: "日本語で" },
    ],
    // 消息通知状态（测试用）
    hasNotification: true,
  }),
  actions: {
    /**
     * 切换消息通知状态
     */
    toggleNotification() {
      this.hasNotification = !this.hasNotification;
    },

    /**
     * 初始化语言设置
     * 从 localStorage 读取用户之前选择的语言，如果没有则使用默认语言 en-US
     * 并同步更新 i18n 插件的语言设置
     */
    initLangs() {
      const cached = localStorage.getItem("app-lang");
      this.lang = cached || "en-US";
      if (!cached) localStorage.setItem("app-lang", this.lang);
      i18n.global.locale.value = this.lang;
    },
    /**
     * 设置应用语言
     * @param {string} lang - 语言代码（如 'en-US', 'zh-CN', 'ja-JP'）
     * 更新 store 状态、i18n 插件配置和 localStorage 缓存
     */
    setLang(lang) {
      this.lang = lang;
      i18n.global.locale.value = lang;
      localStorage.setItem("app-lang", lang);
    },
  },
});
